<template>
  <div id="Map">
    <SovecoNavBar />

    <modal name="search" :draggable="true">
      <div class="columns p-2">
        <div class="column">
          <div class="sr_bold p-3">Ricerca</div>
          <div class="control pb-3">
            <label class="radio"> Testo da ricercare </label>
            <input
              v-model="search_text"
              class="input"
              type="text"
              placeholder="testo da ricercare"
              @keyup.enter="doSearchText"
            />
          </div>
          <!--
          <label class="radio">
            <input
              id="search1"
              v-model="search_selector"
              type="radio"
              value="1"
            />
            Targa
          </label>
          <label class="radio">
            <input
              id="search2"
              v-model="search_selector"
              type="radio"
              value="0"
            />
            Autista
          </label>
          -->
          <div class="pt-6">
            <div class="footer columns">
              <div class="column has-text-centered">
                <span
                  class="button is-small is-danger buttonsize"
                  @click="closeSearch"
                  >Annulla</span
                >
              </div>
              <div class="column has-text-centered">
                <span
                  class="button is-small is-success buttonsize"
                  @click="doSearchText()"
                  >Cerca</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="sr_bold p-3">Risultati</div>
          <div class="search_box box">
            <ul id="elements" class="p-2 sr_history_table">
              <li
                v-for="item in search_elements"
                :key="item.cod"
                @click="selectSearch(item)"
                :class="[
                  search_selected !== null
                    ? search_selected.cod === item.cod
                      ? 'is-item-selected'
                      : 'is-item-not-selected'
                    : 'is-item-not-selected',
                  '',
                ]"
              >
                <div class="columns">
                  <div class="column is-narrow">
                    {{ item.targa }}
                  </div>
                  <div class="column">{{ item.cognome }} {{ item.nome }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </modal>

    <div class="columns is-variable is-0">
      <div class="column sr_col_map">
        <transition name="slide-fade" mode="out-in">
          <div v-if="historyShow" key="1" class="sr_history_box">
            <div v-if="historyCmdsShow" id="cmds">
              <table width="100%">
                <tr>
                  <td width="2%">
                    <span
                      class="button is-info is-pretty_small is-pulled-left"
                      @click="closeHistory"
                      >&lt;</span
                    >
                  </td>
                  <td width="40%">
                    <div class="sr_bold is-pulled-left">
                      {{ selectedItem.targa }}
                    </div>
                  </td>
                  <td width="5%">
                    <span class="icon is-small">
                      <img
                        :src="[
                          activeHistoryOrderDir === 1
                            ? 'images/icon_sort_down.png'
                            : 'images/icon_sort_up.png',
                        ]"
                        @click.prevent="handleHistoryOrderDir"
                      />
                    </span>
                  </td>
                  <td width="20%">
                    <span
                      class="button is-info is-pretty_small is-pulled-right"
                      @click="historyCriteriaSwitch(false)"
                      >CRITERI DI SELEZIONE</span
                    >
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <div class="sr_bold">{{ getDriverName(selectedItem) }}</div>
                  </td>
                </tr>
              </table>

              <table class="sr_history_table">
                <tr>
                  <td>
                    <div class="sr_history_table_label">Dal</div>
                  </td>
                  <TD>&nbsp;</TD>
                  <td>
                    <date-picker
                      v-model="startData"
                      type="datetime"
                      value-type="YYYY-MM-DD HH:mm"
                      format="DD-MM-YYYY HH:mm"
                      confirm
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <div class="sr_history_table_label">Al</div>
                  </td>
                  <TD>&nbsp;</TD>
                  <td>
                    <date-picker
                      v-model="endData"
                      type="datetime"
                      value-type="YYYY-MM-DD HH:mm"
                      format="DD-MM-YYYY HH:mm"
                      confirm
                    />
                  </td>
                </tr>
              </table>

              <table class="sr_history_table">
                <tr>
                  <td>
                    <input
                      v-model="tripSel"
                      type="checkbox"
                      :disabled="checkTripSel()"
                    />&nbsp;Raggruppate per viaggio
                  </td>
                  <!--<td><input type="checkbox" v-model="waypoints" :disabled="checkTripSel()">&nbspWaypoints</td>-->
                </tr>
              </table>

              <div id="CS" class="CS">
                <label class="typo__label">Filtri</label>
                <Multiselect
                  v-model="tagValues"
                  tag-placeholder="Aggiungi filtro"
                  placeholder="Cerca/aggiunge filtro"
                  select-label="Premi return per selezionare"
                  selected="Selezionato"
                  deselect-label="Premi return per rimuovere"
                  label="segnale"
                  track-by="id"
                  :options="tags"
                  :multiple="true"
                  :taggable="true"
                  @tag="addTag"
                />
              </div>

              <section>
                <div class="pad_bottom has-text-centered">
                  <BUTTON
                    class="button is-success buttonsize is-small"
                    @click="doSearch(true)"
                    >CERCA</BUTTON
                  >
                </div>
              </section>
            </div>
            <div v-else id="criteria">
              <table width="100%">
                <tr>
                  <td width="2%">
                    <span
                      class="button is-info is-pretty_small is-pulled-left"
                      @click="closeHistory"
                      >&lt;</span
                    >
                  </td>
                  <td width="40%">
                    <div class="sr_bold is-pulled-left">
                      {{ selectedItem.targa }}
                    </div>
                  </td>
                  <td width="5%">
                    <span class="icon is-small">
                      <img
                        :src="[
                          activeHistoryOrderDir === 1
                            ? 'images/icon_sort_down.png'
                            : 'images/icon_sort_up.png',
                        ]"
                        @click.prevent="handleHistoryOrderDir"
                      />
                    </span>
                  </td>
                  <td width="20%">
                    <span
                      class="button is-info is-pretty_small is-pulled-right"
                      @click="historyCriteriaSwitch(true)"
                      >CRITERI DI SELEZIONE</span
                    >
                  </td>
                </tr>
              </table>
            </div>

            <div v-if="tripSel" id="trip_list" class="sr_col_scroll">
              <div v-if="isLoading" class="spinner">
                <VueElementLoading
                  :active="isLoading"
                  spinner="ring"
                  color="#0000FF"
                />
              </div>
              <ul id="mainlist">
                <li
                  v-for="item in tripPos"
                  :key="item.id"
                  @click="selectTripEntry(item)"
                >
                  <TripBox
                    :prop-obj="item"
                    :selected-cod="selectedTripItem.id"
                    :class="[
                      selectedTripItem.id === item.id
                        ? 'is-item-selected'
                        : 'is-item-not-selected',
                      '',
                    ]"
                  />
                </li>
              </ul>
            </div>
            <div v-else>
              <div id="trip_list" class="sr_col_scroll">
                <div v-if="isLoading" class="spinner">
                  <VueElementLoading
                    :active="isLoading"
                    spinner="ring"
                    color="#0000FF"
                  />
                </div>
                <ul id="mainlist">
                  <li
                    v-for="item in tripPos"
                    :key="item.id"
                    @click="selectHistoryEntry(item)"
                  >
                    <HistoryBox
                      :prop-obj="item"
                      :vehicleObj="selectedItem"
                      :selected-cod="selectedHistoryItem.id"
                      :class="[
                        selectedHistoryItem.id === item.id
                          ? 'is-item-selected'
                          : 'is-item-not-selected',
                        '',
                      ]"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div v-else key="2">
            <!-- ORDER BAR -->
            <div class="sr_order_bar">
              <div :class="[isOrderActive ? 'is-active' : '', 'dropdown']">
                <div class="dropdown-trigger is-vertical-center is-size-7">
                  <button
                    class="button"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu"
                    @click.stop.prevent="isOrderActive = !isOrderActive"
                  >
                    <span class="is-size-7">Ordine</span>
                    <span class="icon is-small">
                      <img src="images/down.png" />
                    </span>
                  </button>
                  <span class="icon is-small">
                    <img
                      :src="[
                        activeOrderDir === 1
                          ? 'images/icon_sort_down.png'
                          : 'images/icon_sort_up.png',
                      ]"
                      @click.prevent="handleOrderDir"
                    />
                  </span>
                  {{ orderActive[activeOrderItem] }}
                </div>
                <div id="dropdown-menu" class="dropdown-menu" role="menu">
                  <div class="dropdown-content">
                    <a
                      :class="[
                        activeOrderItem === 0 ? 'is-active' : '',
                        'dropdown-item',
                      ]"
                      @click.prevent="handleOrderMenu(0)"
                      >Targa</a
                    >
                    <a
                      :class="[
                        activeOrderItem === 1 ? 'is-active' : '',
                        'dropdown-item',
                      ]"
                      @click.prevent="handleOrderMenu(1)"
                      >Autista</a
                    >
                    <a
                      :class="[
                        activeOrderItem === 2 ? 'is-active' : '',
                        'dropdown-item',
                      ]"
                      @click.prevent="handleOrderMenu(2)"
                      >Data</a
                    >
                    <a
                      :class="[
                        activeOrderItem === 3 ? 'is-active' : '',
                        'dropdown-item',
                      ]"
                      @click.prevent="handleOrderMenu(3)"
                      >In Viaggio</a
                    >
                  </div>
                </div>
              </div>
              <div class="is-pulled-right">
                <img
                  class="sr_center_padding"
                  height="24"
                  width="24"
                  src="images/center.png"
                  @click.prevent="centerAllMarkers"
                />
              </div>
              <div class="is-pulled-right">
                <img
                  class="sr_center_padding"
                  height="24"
                  width="24"
                  src="images/glass.png"
                  @click.prevent="showSearch"
                />
              </div>
            </div>
            <!-- FINE ORDER BAR -->

            <!-- VEHICLES LIST -->
            <div id="map_list" ref="map_list" class="sr_col_scroll">
              <div v-if="isLoading" class="spinner">
                <VueElementLoading
                  :active="isLoading"
                  spinner="ring"
                  color="#0000FF"
                />
              </div>
              <ul id="mainlist">
                <li
                  v-for="item in lastPos"
                  :id="item.cod"
                  :key="item.id"
                  @click="selectEntry(item)"
                >
                  <template v-if="item.role === 1">
                    <PositionTrattoreBox
                      :isLast="isLast(item)"
                      :propObj="item"
                      :selectedCod="selectedItem.cod"
                      :codUser="auth.cod"
                      :token="auth.tkn"
                      :api_server="api_server"
                      :class="[
                        selectedItem.cod === item.cod
                          ? 'is-item-selected'
                          : 'is-item-not-selected',
                        '',
                      ]"
                    />
                  </template>
                  <template v-else-if="item.role === 0">
                    <PositionBox
                      :isLast="isLast(item)"
                      :propObj="item"
                      :selectedCod="selectedItem.cod"
                      :codUser="auth.cod"
                      :token="auth.tkn"
                      :api_server="api_server"
                      :class="[
                        selectedItem.cod === item.cod
                          ? 'is-item-selected'
                          : 'is-item-not-selected',
                        '',
                      ]"
                    />
                  </template>
                </li>
              </ul>
            </div>
          </div>
        </transition>
        <!-- FINE VEHICLES LIST -->
      </div>
      <!-- MAP COLUMN -->

      <div id="map_column" class="column cruscottoHost">
        <div v-if="isCruscottoOn" class="cruscotto" ref="cruscottoRef">
          <Cruscotto
            ref="cruscotto"
            :dataCards="dataCards"
            :lastDataStory="lastDataStory"
            :lastPos="lastPosCruscotto"
            :vehicle="vehicle"
            :drivers="drivers"
            :start="start"
            :end="end"
          />
        </div>
        <div style="display: none">
          <div id="gmapoverlay" class="has-text-centered pt-1">
            <div v-if="controlVisible">
              <span
                :class="[
                  actionPlayState ? 'is-danger' : 'is-success',
                  'button is-small gmapoverlay',
                ]"
                @click="actionPlay()"
                >{{ actionPlayState ? 'STOP' : 'PLAY' }}</span
              >
            </div>
          </div>
        </div>

        <GmapMap
          id="gmap"
          ref="mmm"
          class="map-container"
          :center="center"
          :zoom="zoom"
          @zoom_changed="zoomChange"
        >
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="closeInfoWindow"
          >
            <div v-if="selMarker !== null" class="infoWin">
              <div v-if="imageSrc.length > 0" class="vehicle-image-container">
                <img
                  v-if="imageSrc"
                  :src="imageSrc"
                  alt="Image"
                  class="vehicle-image-info"
                />
              </div>
              <table>
                <tr>
                  <th>{{ selectedItem.targa }}</th>
                  <th>
                    {{ selectedItem.cognome }}&nbsp;{{ selectedItem.nome }}
                  </th>
                </tr>
                <tr>
                  <th />
                  <th>{{ selMarker.nick }}</th>
                </tr>
                <tr>
                  <td>{{ reverseDateSoloSolo(selMarker.date) }}</td>
                  <td>{{ timeSolo(selMarker.date) }}</td>
                </tr>
                <tr>
                  <td>{{ getStatoMezzo(selMarker.mode) }}</td>
                  <td>km/h&nbsp;{{ selMarker.speed }}</td>
                </tr>
                <tr v-if="!historyShow">
                  <td colspan="2">
                    {{ calcPausaGuida(selMarker.date, selMarker.mode) }}
                  </td>
                </tr>
                <tr v-if="!selMarker.oscurata">
                  <td colspan="2">
                    {{ addressSplitter(selMarker.address, 0) }}
                  </td>
                </tr>
                <tr v-if="!selMarker.oscurata">
                  <td colspan="2">
                    {{ addressSplitter(selMarker.address, 1) }}
                  </td>
                </tr>
                <tr v-if="!selMarker.oscurata">
                  <td>Lat.&nbsp;{{ selMarker.latitude }}</td>
                  <td>Long.&nbsp;{{ selMarker.longitude }}</td>
                </tr>
                <tr v-if="selMarker.oscurata">
                  <td colspan="2">---</td>
                </tr>
                <tr>
                  <td>Head&nbsp;{{ formatDirection(selMarker.direction) }}</td>
                  <td />
                </tr>
                <tr v-if="hasSondeCarb(selectedItem)">
                  <td>Totale Carburante :&nbsp;{{ selMarker.v0 }}&nbsp;L</td>
                  <td />
                </tr>
                <tr>
                  <td v-if="checkSonda(1, 'C')">
                    Sonda 1 :&nbsp;{{ selMarker.v1 | sondenull_filter }}&nbsp;L
                  </td>
                  <td v-if="checkSonda(2, 'C')">
                    Sonda 2 :&nbsp;{{ selMarker.v2 | sondenull_filter }}&nbsp;L
                  </td>
                </tr>
                <tr>
                  <td v-if="checkSonda(3, 'C')">
                    Sonda 3 :&nbsp;{{ selMarker.v3 | sondenull_filter }}&nbsp;L
                  </td>
                  <td v-if="checkSonda(4, 'C')">
                    Sonda 4 :&nbsp;{{ selMarker.v4 | sondenull_filter }}&nbsp;L
                  </td>
                </tr>
                <tr>
                  <td v-if="checkSonda(1, 'T')">
                    Sonda 1 :&nbsp;{{ selMarker.v1 | sondenull_filter }}&nbsp;C°
                  </td>
                  <td v-if="checkSonda(2, 'T')">
                    Sonda 2 :&nbsp;{{ selMarker.v2 | sondenull_filter }}&nbsp;C°
                  </td>
                </tr>
                <tr>
                  <td v-if="checkSonda(3, 'T')">
                    Sonda 3 :&nbsp;{{ selMarker.v3 | sondenull_filter }}&nbsp;C°
                  </td>
                  <td v-if="checkSonda(4, 'T')">
                    Sonda 4 :&nbsp;{{ selMarker.v4 | sondenull_filter }}&nbsp;C°
                  </td>
                </tr>
              </table>
            </div>
            <div v-if="selPOI !== null">{{ selPOI.description }}</div>
          </gmap-info-window>
          <template v-if="google !== undefined || google !== null">
            <GmapMarker
              v-for="m in poisRow"
              :key="m.id"
              :position="{
                lat: parseFloat(m.latitude),
                lng: parseFloat(m.longitude),
              }"
              :z-index="1000"
              :clickable="true"
              :draggable="false"
              :icon="createIcon(m, zoomNow, google)"
              @click="toggleInfoWindow(m, false)"
            />
          </template>
          <div
            v-if="
              !historyShow &&
              (google !== undefined || google !== null) &&
              (prefs !== null || prefs !== undefined)
            "
          >
            <GmapMarker
              v-for="m in lastPosVisibili"
              :key="m.cod"
              :z-index="selectedItem.cod === m.cod ? 99999999 : 10000"
              :position="{
                lat: parseFloat(m.latitude),
                lng: parseFloat(m.longitude),
              }"
              :clickable="true"
              :draggable="false"
              :icon="getIcon(m)"
              @click="toggleInfoWindow(m, true)"
            />
          </div>
          <div
            v-if="
              historyShowHistory() && (google !== undefined || google !== null)
            "
          >
            <GmapMarker
              v-for="m in tripPos"
              :key="m.id"
              :z-index="selectedHistoryItem.id === m.id ? 99999999 : 10000"
              :position="{
                lat: parseFloat(m.latitude),
                lng: parseFloat(m.longitude),
              }"
              :clickable="true"
              :draggable="false"
              :icon="getHistoryIcon(m, selectedHistoryItem.id === m.id)"
              @click="toggleInfoWindow(m, true)"
            />
          </div>
          <div
            v-if="
              tripSingle.length > 0 &&
              waypoints &&
              actionPlayState === false &&
              (google !== undefined || google !== null)
            "
          >
            <GmapMarker
              v-for="m in tripSingle"
              :key="m.id"
              :z-index="1000"
              :position="{
                lat: parseFloat(m.latitude),
                lng: parseFloat(m.longitude),
              }"
              :clickable="true"
              :draggable="false"
              :icon="getHistoryIcon(m, m.sosta === 1)"
              @click="toggleInfoWindow(m, true)"
            />
          </div>
          <div
            v-if="
              historyShowTrip() && (google !== undefined || google !== null)
            "
          >
            <GmapMarker
              :position="{
                lat: parseFloat(selectedTripItem.obj_s.latitude),
                lng: parseFloat(selectedTripItem.obj_s.longitude),
              }"
              :clickable="false"
              :draggable="false"
              :icon="getStartEndIcon(selectedTripItem.inizio, false)"
            />
            <GmapMarker
              :position="{
                lat: parseFloat(selectedTripItem.obj_e.latitude),
                lng: parseFloat(selectedTripItem.obj_e.longitude),
              }"
              :clickable="false"
              :draggable="false"
              :icon="getStartEndIcon(selectedTripItem.fine, true)"
            />
          </div>
        </GmapMap>
      </div>
    </div>
  </div>
</template>
<script>
import { ServiceBus } from '../ServiceBus.js'
import { UtilityMixin } from '../mixins/UtilityMixin.js'
import PositionBox from './reusable/PositionBox.vue'
import PositionTrattoreBox from './reusable/PositionTrattoreBox.vue'

import TripBox from './reusable/TripBox.vue'
import HistoryBox from './reusable/HistoryBox.vue'
import Multiselect from 'vue-multiselect'
import VueElementLoading from 'vue-element-loading'
import { gmapApi } from 'gmap-vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/it'
import Cruscotto from './reusable/Cruscotto.vue'
export default {
  name: 'Map',
  components: {
    PositionBox,
    PositionTrattoreBox,
    TripBox,
    HistoryBox,
    Multiselect,
    VueElementLoading,
    DatePicker,
    Cruscotto,
  },
  mixins: [UtilityMixin],
  data() {
    return {
      imageSrc: null,
      possibleExtensions: ['jpg', 'png', 'jpeg', 'gif'],
      search_selected: null,
      search_selector: '1',
      search_text: '',
      search_elements: [],
      kKey0: 1,
      kKey1: 67000,
      format: 'DD-MM-YYYY HH:mm',
      infoContent: '-',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: 0,
        },
      },
      isLoading: false,
      selMarker: null,
      selPOI: null,
      waypoints: true,
      tripSel: false,
      updateInterval: null,
      startData: '',
      endData: '',
      historyShow: false,
      historyCmdsShow: false,
      auth: null,
      prefs: null,
      windowHeight: 0,
      poisRow: [],
      tripPos: [],
      tripAllPos: [],
      tripSingle: [],
      lastPos: [],
      tags: [],

      tagValues: [],
      zoomNow: 12,
      zoom: 12,
      center: {
        lat: 45,
        lng: 11,
      },
      latlngbounds: null, // new google.maps.LatLngBounds(),
      isOrderActive: false,
      selectedItemScrollValue: 0,
      selectedItem: {
        cod: '',
      },
      selectedHistoryItem: {
        id: '',
      },
      selectedTripItem: {
        id: '',
      },
      activeHistoryOrderDir: 0,
      activeOrderDir: 0,
      activeOrderItem: 0,
      orderActive: ['Targa', 'Autista', 'Data', 'In Viaggio'],
      directionsDisplay: null,
      animationInterval: null,
      api_server: '',
      actionPlayState: false,
      controlVisible: false,
      selectCircle: null,
      isCruscottoOn: false,
      tacoCardRecent: null,
      lastDataPos: null,
      lastDataBackPos: null,
      drivers: [],
      vehicle: null,
      lastPosCruscotto: null,
      lastDataStory: null,
      dataCards: null,
      start: null,
      end: null,
      value: [],
      options: [],
      conducenti: [],
    }
  },
  watch: {
    tripSel(val) {
      const vm = this
      vm.doTripSel()
    },
  },
  beforeRouteLeave(to, from, next) {
    const vm = this
    vm.doUpdateLastPos(false)
    window.removeEventListener('resize', vm.getWindowHeight)
    next()
  },
  mounted() {
    console.log('PPPPPPPPP')
    const vm = this
    vm.api_server = vm.getApiServer()
    ServiceBus.setApi(vm.api_server)
    ServiceBus.setAuth(vm.auth)
    if (vm.auth === null) {
      vm.$router.push({
        path: 'login',
      })
    }

    vm.doGetConducenti()
    ServiceBus.$on('rimorchioClick', (obj) => {
      this.selectEntry(obj)
    })
    ServiceBus.$on('showRow', (cod) => {
      const vm = this
      setTimeout(function () {
        vm.selectedItem = vm.findObjInArray(vm.lastPos, 'cod', cod)
      }, 3000)
    })
    ServiceBus.$on('cruscottoClear', () => {
      vm.doCruscottoClear()
    })
    ServiceBus.$on('centerSosta', (pos) => {
      pos.obj_s.sosta = 1
      vm.centerMarker(pos.obj_s)
    })
    ServiceBus.$on('showMore', () => {
      vm.$refs['map_list'].scrollTop =
        vm.$refs['map_list'].scrollHeight - vm.$refs['map_list'].clientHeight
    })
    ServiceBus.$on('setShort', () => {
      vm.$refs['cruscottoRef'].style.width = '680px'
    })
    ServiceBus.$on('setMax', () => {
      vm.$refs['cruscottoRef'].style.width = '100%'
    })

    ServiceBus.$on('showHistory', (cod) => {
      const vm = this
      vm.doUpdateLastPos(false)
      vm.clearCircle()
      vm.historyShow = true
      vm.tagValues = []
      vm.selectedItem = vm.findObjInArray(vm.lastPos, 'cod', cod)
      let d = vm.newDate(vm.selectedItem.date)
      vm.endData = d.toLocaleMysqlString() //d.toISOString()
      d.setDate(d.getDate() - 1)
      d.setHours(0)
      d.setMinutes(0)
      d.setSeconds(0)
      vm.startData = d.toLocaleMysqlString() // d.toISOString()
      vm.tripPos = []
      vm.tripSel = vm.prefs.storico > 1
      vm.historyCmdsShow = false
      vm.closeInfoWindow()
      setTimeout(function () {
        vm.controlVisible = true
        vm.selectedItem = vm.findObjInArray(vm.lastPos, 'cod', cod)
        vm.doSearch(false)
      }, 1000)
    })

    vm.getWindowHeight()
    vm.$nextTick(function () {
      vm.doUpdateLastPos(true)
      window.addEventListener('resize', vm.getWindowHeight)
      //vm.$refs.mmm.$mapPromise.then(map => {});
      setTimeout(function () {
        vm.toggleInfoWindow(vm.lastPos[0])
        vm.toggleInfoWindow(vm.lastPos[0])
      }, 6000)
      setTimeout(function () {
        let v_cod = vm.$localStorage.get('vehicles_cod')
        vm.getWindowHeight()
        if (v_cod !== '' && v_cod !== null) {
          let a = vm.findObjInArray(vm.lastPos, 'cod', v_cod)
          //let idx = vm.findObjIndexInArray(vm.lastPos, 'cod', v_cod)
          vm.selectEntry(a)
          // vm.scrollToVisible(idx)
          vm.makeElementVisible(a.cod)
          vm.$localStorage.set('vehicles_cod', '')
        }
      }, 500)
      vm.doStuff()
    })
  },
  computed: {
    google: gmapApi,
    lastPosVisibili() {
      return this.lastPos.filter(m => !m.oscurata)
    },
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  methods: {
    loadImage() {
      const vm = this
      if (vm.selectedItem.cod == '') return
      const imgName = vm.auth.cod + '_' + vm.selectedItem.cod

      const postfix = vm.getServerPostfix()
      const basePath =
        'https://www.sovecotech' + postfix + '/sovtech/media/uploads/'
      const defaultImage = ''
      let imageFound = false

      this.possibleExtensions.some((extension) => {
        const imgPath = `${basePath}${imgName}.${extension}?${Date.now()}`
        const img = new Image()

        // Check if the image loads successfully
        img.onload = () => {
          if (!imageFound) {
            this.imageSrc = imgPath // Set the image source to the found image
            imageFound = true // Mark that an image has been found
          }
        }

        // Handle error (image not found for this extension)
        img.onerror = () => {
          if (
            extension ===
              this.possibleExtensions[this.possibleExtensions.length - 1] &&
            !imageFound
          ) {
            this.imageSrc = defaultImage // Set the image to the default image if nothing is found
          }
        }
        img.removeAttribute('src')
        img.src = imgPath

        // Stop if an image is successfully loaded
        return imageFound
      })

      // If no image is found by the end of the loop, set the default image
      if (!imageFound) {
        this.imageSrc = ''
      }
    },

    async showCruscotto(cod) {
      const vm = this
      if (vm.auth.tipo == 3) return
      await vm.doCruscotto(cod)

      vm.isCruscottoOn = true
    },
    doCruscottoClear() {
      const vm = this

      vm.isCruscottoOn = false
      vm.tacoCardRecent = []
      vm.lastDataBackPos = []
      vm.lastDataPos = null
    },

    async doGetConducenti() {
      console.log('doGetConducenti')
      const vm = this
      const drivers = await ServiceBus._doGetDrivers()
      vm.conducenti = drivers.filter((item) => item.fax_1)
      console.log('doGetConducenti', vm.conducenti.length)
    },

    translateConducente(mssg) {
      const vm = this
      if (!vm.conducenti || !vm.conducenti.length) {
        return mssg
      }
      const match = mssg.match(/CONDUCENTE:(\d+)/)
      const cod_conducente = match ? match[1] : null
      if (cod_conducente) {
        const driver = vm.conducenti.find(
          (item) => item.fax_1 == cod_conducente
        )
        if (driver) {
          const fullName = [
            'CONDUCENTE : ',
            driver.nome,
            driver.cognome,
            driver.nick,
          ]
            .filter(Boolean)
            .join(' ')
          return fullName
        }
        return mssg
      } else {
        return mssg
      }
    },

    async doCruscotto(cod) {
      const vm = this
      vm.end = new Date()
      vm.start = new Date()
      vm.start.setDate(vm.start.getDate() - 1)

      // // carico i dati per quel mezzo se esistenti
      vm.lastDataStory = await ServiceBus._getLastDataStory(cod)
      // carico ultima posizione del mezzo per i dati georeferenziati
      vm.lastPosCruscotto = await ServiceBus._getLastPosVehicle(cod)
      // carico i dati del mezzo
      vm.vehicle = await ServiceBus._doGetVehicle(cod)
      // carico le card inserite nell'arco di 24h
      let temp = await ServiceBus._getTacoCardRangeObj(cod, vm.start, vm.end)
      // estraggo i dati in forma chiara
      if (temp && temp.length > 0) {
        vm.dataCards = ServiceBus._analyzeTacoCardRange(temp, cod)
      } else {
        vm.dataCards = null
      }

      vm.isCruscottoOn = true
    },

    isLast(item) {
      const vm = this
      return item.cod === vm.lastPos[vm.lastPos.length - 1].cod
    },

    async doStuff() {
      const vm = this
      vm.tags = await ServiceBus._doGetTags()
      vm.poisRow = await ServiceBus._doGetPois()
      vm.addPlayButton()
      vm.centerAllMarkers()
    },

    checkSonda(n, t) {
      const vm = this
      let b
      switch (n) {
        case 1: {
          b = vm.selMarker.sonda_1 === t || vm.selectedItem.sonda_1 === t
          break
        }
        case 2: {
          b = vm.selMarker.sonda_2 === t || vm.selectedItem.sonda_2 === t
          break
        }
        case 3: {
          b = vm.selMarker.sonda_3 === t || vm.selectedItem.sonda_3 === t
          break
        }
        case 4: {
          b = vm.selMarker.sonda_4 === t || vm.selectedItem.sonda_4 === t
          break
        }
      }
      return b
    },
    formatDirection(direction) {
      return direction < 0 ? '-' : direction + '°'
    },

    makeElementVisible(elementId) {
      // Find the element by its ID
      var element = document.getElementById(elementId)

      // Check if the element exists
      if (element) {
        // Get the parent container of the list
        var container = document.getElementById('map_list')

        // Calculate the offset of the element relative to the container
        var offsetTop = element.offsetTop - container.offsetTop
        var offsetBottom = offsetTop + element.clientHeight

        // Check if the element is fully visible
        var containerTop = container.scrollTop
        var containerBottom = containerTop + container.clientHeight
        if (offsetTop < containerTop || offsetBottom > containerBottom) {
          // Scroll the container to make the element visible
          container.scrollTop = offsetTop
        }
      }
    },

    scrollToVisible(idx) {
      let overflow = document.getElementById('map_list')
      let mainlist = document.getElementById('mainlist')
      let hTr = mainlist.firstChild.clientHeight

      let posTr = idx * hTr // + hTr

      let delta = posTr - overflow.clientHeight / 2

      if (delta > 0) {
        overflow.scrollTop = delta + overflow.clientHeight / 2
      }
    },

    checkSoste(idx) {
      const vm = this
      let nitems = vm.selectedTripItem.tappe.length
      let sosta = 0
      if (nitems < 1) return 0

      for (let i = 0; i < nitems; i++) {
        if (
          idx >= vm.selectedTripItem.tappe[i].idx_s &&
          idx <= vm.selectedTripItem.tappe[i].idx_e
        ) {
          sosta = 1
        }
        return sosta
      }
    },

    addPlayButton() {
      const vm = this
      vm.$refs['mmm'].$mapPromise.then(() => {
        vm.$refs['mmm'].$mapObject.controls[10].push(
          document.getElementById('gmapoverlay')
        )
      })
    },

    actionPlay() {
      const vm = this

      vm.clearCircle()

      vm.actionPlayState = !vm.actionPlayState

      if (vm.actionPlayState) {
        if (!vm.tripSel) {
          vm.playPositions(vm.tripPos)
        } else {
          if (vm.tripSingle.length > 0) vm.playPositions(vm.tripSingle)
        }
      } else {
        vm.clearPolyline()
      }
    },

    playPositions(positions) {
      const vm = this
      let coordinates = []
      for (let i = 0; i < positions.length; i++) {
        let latlng = {
          lat: parseFloat(positions[i].latitude),
          lng: parseFloat(positions[i].longitude),
          sosta: positions[i].sosta,
        }
        coordinates.push(latlng)
      }
      vm.clearPolyline()
      vm.drawPolyline(coordinates)
    },

    clearPolyline() {
      const vm = this
      //vm.tripSingle = [];

      if (vm.directionsDisplay !== null) {
        vm.directionsDisplay.setMap(null)
        vm.directionsDisplay = null
      }
      if (vm.animationInterval !== null) {
        clearInterval(vm.animationInterval)
        vm.animationInterval = null
      }
    },

    drawPolyline(coordinates) {
      const vm = this
      vm.directionsDisplay = new vm.google.maps.Polyline({
        path: coordinates,
        strokeColor: '#ff4646', //"#add8e6",
        strokeWeight: 4,
        strokeOpacity: 1,
      })
      vm.directionsDisplay.setMap(vm.$refs.mmm.$mapObject)
      vm.zoomToObject(vm.directionsDisplay)
      vm.animateCircle()
    },

    animateCircle() {
      const vm = this
      let count = 0
      let lineSymbol = {
        path: vm.google.maps.SymbolPath.CIRCLE,
        scale: 8,
        strokeColor: '#005db5',
        strokeWidth: '#005db5',
      }

      // fallback icon if the poly has no icon to animate
      let defaultIcon = [
        {
          icon: lineSymbol,
          offset: '100%',
        },
      ]

      vm.animationInterval = window.setInterval(function () {
        count = (count + 1) % 200
        if (count === 0) {
          vm.clearPolyline()
          vm.actionPlayState = false
        } else {
          let icons = defaultIcon
          icons[0].offset = count / 2 + '%'
          vm.directionsDisplay.set('icons', icons)
        }
      }, 40)
    },

    displayTrip() {
      const vm = this
      vm.clearPolyline()
      vm.actionPlayState = false
      vm.tripSingle = []
      let i
      for (i = vm.selectedTripItem.idx_s; i < vm.selectedTripItem.idx_e; i++) {
        vm.tripAllPos[i].sosta = vm.checkSoste(i)
        vm.tripSingle.push(vm.tripAllPos[i])
      }
    },

    zoomToObject(obj) {
      const vm = this
      let bounds = new vm.google.maps.LatLngBounds()
      let points = obj.getPath().getArray()
      for (let n = 0; n < points.length; n++) {
        bounds.extend(points[n])
      }
      vm.$refs.mmm.$mapObject.fitBounds(bounds)
    },

    doTripSel() {
      const vm = this
      vm.tripPos = []
      vm.selectedHistoryItem = {}
      vm.selectedHistoryItem.id = ''
      vm.doSearch(false)
    },
    checkTripSel() {
      const vm = this
      if (vm.tagValues.length > 0) {
        vm.tripSel = false
        return true
      }
      return false
    },
    closeHistory() {
      const vm = this
      vm.historyShow = false
      vm.actionPlayState = false
      vm.controlVisible = false

      vm.clearPolyline()
      vm.centerMarker(vm.selectedItem)
      vm.tripPos = []
      vm.tripAllPos = []
      vm.tripSingle = []
      vm.doUpdateLastPos(true)
      vm.closeInfoWindow()

      setTimeout(function () {
        document.getElementById('map_list').scrollTop =
          vm.selectedItemScrollValue
      }, 1500)
    },
    historyCriteriaSwitch(flag) {
      const vm = this
      vm.historyCmdsShow = flag
      if (flag) {
        vm.criteriaTitle = 'CHIUDI CRITERI SELEZIONE'
      } else {
        vm.criteriaTitle = 'APRI CRITERI SELEZIONE'
      }
      setTimeout(function () {
        vm.adjustTripListHeight()
      }, 1500)
    },
    historyShowHistory() {
      const vm = this
      return vm.historyShow && !vm.tripSel
    },
    historyShowTrip() {
      const vm = this
      return vm.historyShow && vm.tripSel && vm.selectedTripItem.id.length > 0
    },
    closeInfoWindow() {
      const vm = this
      vm.infoWinOpen = false
      vm.selMarker = null
    },
    toggleInfoWindow(marker, isPosition) {
      const vm = this
      let idx
      if (isPosition) {
        if (vm.selectedItem.cod !== marker.cod) {
          let a = vm.findObjInArray(vm.lastPos, 'cod', marker.cod)
          // idx = vm.findObjIndexInArray(vm.lastPos, 'cod', marker.cod
          vm.selectEntry(a)
          vm.makeElementVisible(a.cod)
          //vm.scrollToVisible(idx)
        }
        vm.selMarker = marker
        vm.selPOI = null
      } else {
        vm.selPOI = marker
        vm.selMarker = null
      }
      vm.infoWindowPos = {
        lat: parseFloat(marker.latitude),
        lng: parseFloat(marker.longitude),
      }

      //check if its the same marker that was selected if yes toggle
      if (vm.currentMidx === marker.cod + marker.id + '') {
        vm.infoWinOpen = !vm.infoWinOpen
      }
      //if different marker set infowindow to open and reset current marker index
      else {
        vm.infoWinOpen = true
        vm.currentMidx = marker.cod + marker.id + ''
      }
    },
    doRecalcMode() {
      const vm = this
      vm.lastPos.forEach((element) => {
        element.message = vm.translateConducente(element.message)

        if (element.mode > 0) {
          let a = vm.newDate(element.time)
          let b = new Date()
          let d = Math.ceil((b - a) / 3600000)
          element.mode = d
        }
      })
    },
    doUpdateSelectedItem() {
      const vm = this
      if (vm.selectedItem.cod === '') return
      vm.selectedItem = vm.findObjInArray(
        vm.lastPos,
        'cod',
        vm.selectedItem.cod
      )
    },
    async doUpdateLastPos(isActive) {
      const vm = this
      if (isActive) {
        await vm.doGetLastPos()
        vm.updateInterval = setInterval(function () {
          vm.doGetLastPos()
        }, 120000)
      } else if (vm.updateInterval !== null) {
        clearInterval(vm.updateInterval)
        vm.updateInterval = null
      }
    },
    addTag(newTag) {
      const vm = this
      const tag = {
        segnale: newTag,
        id: vm.tags.length + 1,
      }
      vm.tags.push(tag)
      vm.tagValues.push(tag)
    },
    getStartEndIcon(myString, isSelected) {
      const vm = this
      let mySvg = vm.getStartEndSvg(myString, isSelected)
      let myIcon = {
        url: mySvg,
        anchor: new vm.google.maps.Point(22, 60),
        size: new vm.google.maps.Size(55, 61),
      }
      return myIcon
    },
    getHistoryIcon(m, isSelected) {
      const vm = this
      let mySvg = vm.getOrientedSvg(m, isSelected)
      let myIcon = {
        url: mySvg,
        anchor: new vm.google.maps.Point(8, 8),
        size: new vm.google.maps.Size(16, 16),
      }
      return myIcon
    },
    getIcon(obj) {
      const vm = this
      let myIcon
      let mySvg = vm.getSvgIcon(obj.mode, obj.targa, vm.prefs)
      myIcon = {
        url: mySvg,
        anchor: new vm.google.maps.Point(22, 60),
        size: new vm.google.maps.Size(55, 61),
      }
      return myIcon
    },
    clear_search() {
      const vm = this
      vm.tripPos = []
    },
    doSearch(showDialog) {
      const vm = this
      if (vm.auth.tipo === 3) {
        let flag = false
        if (vm.startData < vm.auth.inizio) {
          vm.startData = vm.auth.inizio
          flag = true
        }
        if (vm.startData > vm.auth.fine) {
          vm.startData = vm.auth.inizio
          flag = true
        }
        if (vm.endData > vm.auth.fine) {
          vm.endData = vm.auth.fine
          flag = true
        }
        if (vm.endData < vm.auth.inizio) {
          vm.endData = vm.auth.fine
          flag = true
        }
        if (showDialog && flag) {
          vm.$dialog
            .alert(
              'Questo utente è abilitato alla consultazione del periodo dal ' +
                vm.reverseDateSoloSolo(vm.auth.inizio) +
                ' al ' +
                vm.reverseDateSoloSolo(vm.auth.fine)
            )
            .then(function () {})
            .catch(function () {})
        }
      }

      vm.tripPos = []
      vm.clearPolyline()
      vm.actionPlayState = false
      //cancellato
      vm.adjustTripListHeight()
      vm.doGetPos()
    },
    async doGetPos() {
      const vm = this
      vm.isLoading = true
      let start = vm.newDate(vm.startData).toLocaleMysqlString()
      let end = vm.newDate(vm.endData).toLocaleMysqlString()
      const rdata = await ServiceBus._doGetPos(
        vm.tagValues,
        vm.selectedItem.cod,
        start,
        end
      )
      vm.isLoading = false

      if (rdata.length === 0) {
        vm.$dialog
          .alert('Nessuna posizione per questi criteri di selezione')
          .then(function () {})
          .catch(function () {})
      } else {
        vm.applicaOscuramentoPosizioni(rdata, vm.auth)
        console.log('pass1')
        vm.calcHeading(rdata)
        console.log('pass2')
        rdata.forEach((element) => {
          element.message = vm.translateConducente(element.message)
        })
        console.log('pass3')
        if (vm.tripSel) {
          vm.tripPos = []
          vm.tripPos = vm.calcJourneys(
            vm.extractJourney(
              vm.newDate(vm.startData),
              vm.newDate(vm.endData),
              rdata
            )
          )
          vm.tripAllPos = rdata
          vm.tripSel = vm.tripPos.length > 0
        }
        if (!vm.tripSel) {
          vm.tripPos = rdata
          vm.centerAllHistoryMarkers()
        }
        vm.historyCriteriaSwitch(false)
        vm.sortHistoryList()
      }
    },
    centerStuff() {
      const vm = this
      if (vm.selectedItem.cod == '') {
        vm.centerAllMarkers()
      } else {
        vm.centerMarker(vm.selectedItem)
      }
    },

    async setAbbinamenti2() {
      const vm = this
      const newLastPos = []
      const couples = await ServiceBus._doGetAbbinamenti(vm.prefs.distance)
      if (couples.length > 0) {
        vm.lastPos.forEach((element) => {
          let obj1 = couples.find((item) => item.vehicle1_cod == element.cod)
          if (obj1) {
            element.targaKey = obj1.vehicle1_targa + '|A|' + obj1.vehicle2_targa
            element.couple = obj1
            element.role = 1 // trattore
            element.rimorchio = vm.lastPos.find(
              (item) => item.cod == obj1.vehicle2_cod
            )
            element.rimorchio.role = 2
            newLastPos.push(element)
          }
          let obj2 = couples.find((item) => item.vehicle2_cod == element.cod)

          if (obj1 === undefined && obj2 === undefined) {
            element.targaKey = element.targa + '|=|' + element.targa
            element.couple = []
            element.role = 0 // free
            newLastPos.push(element)
          }
        })
        vm.lastPos = newLastPos
      } else {
        vm.lastPos.forEach((element) => {
          element.targaKey = element.targa
          element.couple = []
          element.role = 0 // free
        })
      }
    },

    async setAbbinamenti() {
      const vm = this
      const couples = await ServiceBus._doGetAbbinamenti(vm.prefs.distance)
      if (couples.length > 0) {
        vm.lastPos.forEach((element) => {
          let obj1 = couples.find((item) => item.vehicle1_cod == element.cod)
          if (obj1) {
            element.targaKey = obj1.vehicle1_targa + '|A|' + obj1.vehicle2_targa
            element.couple = obj1
            element.role = 1 // trattore
            element.rimorchio = vm.lastPos.find(
              (item) => item.cod == obj1.vehicle2_cod
            )
            element.rimorchio.role = 2
          }
          let obj2 = couples.find((item) => item.vehicle2_cod == element.cod)
          if (obj2) {
            element.targaKey = obj2.vehicle1_targa + '|B|' + obj2.vehicle2_targa
            element.couple = obj2
            element.role = 2 // rimorchio
          }
          if (obj1 === undefined && obj2 === undefined) {
            element.targaKey = element.targa + '|=|' + element.targa
            element.couple = []
            element.role = 0 // free
          }
        })
      } else {
        vm.lastPos.forEach((element) => {
          element.targaKey = element.targa
          element.couple = []
          element.role = 0 // free
        })
      }
    },

    async doGetLastPos() {
      const vm = this
      vm.isLoading = true
      const rdata = await ServiceBus._doGetLastPos()
      vm.isLoading = false
      if (rdata.length > 0) {
        vm.lastPos = rdata
        vm.applicaOscuramentoPosizioni(vm.lastPos, vm.auth)

        vm.doRecalcMode()
        vm.doUpdateSelectedItem()
        if (vm.prefs.coupling == 1) {
          await vm.setAbbinamenti()
        } else {
          vm.lastPos.forEach((element) => {
            element.targaKey = element.targa
            element.couple = []
            element.role = 0 // free
          })
        }
        vm.sortList()
        if (vm.google === undefined || vm.google === null) {
          setTimeout(function () {
            vm.centerStuff()
          }, 3000)
        } else {
          vm.centerStuff()
        }
        console.log('lastPos', vm.lastPos)
        setTimeout(function () {
          vm.kKey0 += 1
          vm.kKey1 += 1
          vm.adjustMapListHeight()
        }, 1000)
      }
    },

    selectTripEntry(pos) {
      const vm = this
      if (vm.selectedTripItem.id === pos.id) {
        vm.selectedTripItem = {}
        vm.selectedTripItem.id = ''
      } else {
        vm.selectedTripItem = pos
      }
      vm.centerTripMarkers()
      vm.displayTrip()
    },
    selectHistoryEntry(pos) {
      const vm = this
      if (vm.selectedHistoryItem.id === pos.id) {
        vm.selectedHistoryItem = {}
        vm.selectedHistoryItem.id = ''
      } else {
        vm.selectedHistoryItem = pos
      }
      if (vm.selectedHistoryItem.id !== '') {
        vm.centerMarker(vm.selectedHistoryItem)
      } else {
        vm.centerAllHistoryMarkers()
      }
    },
    async selectEntry(pos) {
      const vm = this
      vm.doCruscottoClear()
      vm.selectedItemScrollValue = document.getElementById('map_list').scrollTop

      if (pos.address == null) {
        vm.$dialog
          .alert('Nessuna posizione per questo mezzo')
          .then(function () {})
          .catch(function () {})
      } else {
        if (vm.selectedItem.cod === pos.cod) {
          vm.selectedItem = {}
          vm.selectedItem.cod = ''
        } else {
          vm.selectedItem = pos

          vm.fileExists = vm.loadImage()
        }

        if (vm.selectedItem.cod !== '') {
          vm.centerMarker(vm.selectedItem)
        } else {
          vm.centerAllMarkers()
        }
      }

      if (vm.historyShow === false && vm.auth.tipo != 3) {
        vm.showCruscotto(pos.cod)
      }
    },
    handleOrderDir() {
      const vm = this
      if (vm.activeOrderDir === 1) {
        vm.activeOrderDir = 0
      } else {
        vm.activeOrderDir = 1
      }
      vm.sortList()
    },
    handleOrderMenu(item) {
      const vm = this
      vm.activeOrderItem = item
      vm.isOrderActive = false
      vm.sortList()
    },
    sortList() {
      const vm = this
      if (vm.activeOrderDir < 1) {
        switch (vm.activeOrderItem) {
          case 0:
            vm.lastPos.sort(vm.sortForTargaKeyAsc)
            break
          case 1:
            vm.lastPos.sort(vm.sortForDriverAsc)
            break
          case 2:
            vm.lastPos.sort(vm.sortForDateAsc)
            break
          case 3:
            vm.lastPos.sort(vm.sortForModeAsc)
            break
        }
      } else {
        switch (vm.activeOrderItem) {
          case 0:
            vm.lastPos.sort(vm.sortForTargaKeyDesc)
            break
          case 1:
            vm.lastPos.sort(vm.sortForDiverDesc)
            break
          case 2:
            vm.lastPos.sort(vm.sortForDateDesc)
            break
          case 3:
            vm.lastPos.sort(vm.sortForModeDesc)
            break
        }
      }
    },
    sortHistoryList() {
      const vm = this
      if (vm.activeHistoryOrderDir < 1) {
        vm.tripPos.sort(function (a, b) {
          if (a.date > b.date) return 1
          if (a.date < b.date) return -1
          return 0
        })
      } else {
        vm.tripPos.sort(function (a, b) {
          if (a.date > b.date) return -1
          if (a.date < b.date) return 1
          return 0
        })
      }
    },
    handleHistoryOrderDir() {
      const vm = this
      if (vm.activeHistoryOrderDir === 1) {
        vm.activeHistoryOrderDir = 0
      } else {
        vm.activeHistoryOrderDir = 1
      }
      vm.sortHistoryList()
    },
    clearCircle() {
      const vm = this
      if (vm.selectCircle) {
        vm.selectCircle.setMap(null)
      }
    },
    showSearch() {
      this.$modal.show('search')
    },
    closeSearch() {
      this.$modal.hide('search')
    },
    selectSearch(element) {
      const vm = this
      vm.search_selected = element

      //let a = vm.findObjInArray(vm.lastPos, 'cod', element.cod)
      //let idx = vm.findObjIndexInArray(vm.lastPos, 'cod', element.cod)
      vm.selectEntry(element)
      //vm.scrollToVisible(idx)
      vm.makeElementVisible(element.cod)
      vm.closeSearch()
    },
    arrayUnique(array) {
      var a = array.concat()
      for (var i = 0; i < a.length; ++i) {
        for (var j = i + 1; j < a.length; ++j) {
          if (a[i].cod === a[j].cod) a.splice(j--, 1)
        }
      }
      return a
    },
    doSearchText() {
      const vm = this
      vm.search_elements = []
      vm.search_selected = null
      let arr1 = []
      let arr2 = []
      // if (vm.search_selector === '1') {
      arr1 = vm.findStringByStartingCharacters(
        vm.lastPos,
        vm.search_text,
        'targa'
      )
      //  } else {
      arr2 = vm.findStringByStartingCharacters(
        vm.lastPos,
        vm.search_text,
        'cognome'
      )
      //   }
      vm.search_elements = vm.arrayUnique(arr1.concat(arr2))
    },

    centerMarker(item) {
      const vm = this
      if (item.oscurata) return
      let pos = {
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude),
      }
      let bounds = vm.getPosBounds(pos, vm.google)
      vm.$refs.mmm.$mapPromise.then(() => {
        vm.$refs.mmm.$mapObject.fitBounds(bounds)
        vm.center = vm.$refs.mmm.$mapObject.getCenter()
        vm.clearCircle()
        vm.selectCircle = new vm.google.maps.Circle({
          strokeColor: '#00DD00',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#00AA00',
          fillOpacity: 0.15,
          map: vm.$refs.mmm.$mapObject,
          center: pos,
          radius: 500,
        })
      })
    },
    centerAllMarkers() {
      const vm = this
      vm.selectedItem = {}
      vm.selectedItem.cod = ''
      let bounds = vm.getMapBounds(vm.lastPos, vm.google)
      vm.$refs.mmm.$mapPromise.then(() => {
        vm.$refs.mmm.$mapObject.fitBounds(bounds)
        vm.center = vm.$refs.mmm.$mapObject.getCenter()
      })
    },
    centerTripMarkers() {
      const vm = this
      let bounds = vm.getTripMapBounds(vm.selectedTripItem, vm.google)
      vm.$refs.mmm.$mapPromise.then(() => {
        vm.$refs.mmm.$mapObject.fitBounds(bounds)
        vm.center = vm.$refs.mmm.$mapObject.getCenter()
      })
    },
    centerAllHistoryMarkers() {
      const vm = this
      vm.selectedHistoryItem = {}
      vm.selectedHistoryItem.id = ''
      let bounds = vm.getMapBounds(vm.tripPos, vm.google)
      vm.$refs.mmm.$mapPromise.then(() => {
        vm.$refs.mmm.$mapObject.fitBounds(bounds)
        vm.center = vm.$refs.mmm.$mapObject.getCenter()
      })
    },
    zoomChange(e) {
      const vm = this
      vm.zoomNow = e
    },
    adjustTripListHeight() {
      const vm = this
      if (vm.historyShow) {
        let tripListH
        let cmdsH
        if (vm.historyCmdsShow) {
          cmdsH = document.getElementById('cmds').clientHeight
        } else {
          cmdsH = document.getElementById('criteria').clientHeight
        }
        tripListH = vm.windowHeight - 70 - cmdsH
        document
          .getElementById('trip_list')
          .setAttribute('style', 'height:' + tripListH + 'px')
      }
    },
    adjustMapListHeight() {
      const vm = this
      document
        .getElementById('map_list')
        .setAttribute('style', 'height:' + (vm.windowHeight - 110) + 'px')
    },
    getWindowHeight(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight
      document
        .getElementById('gmap')
        .setAttribute('style', 'height:' + (vm.windowHeight - 70) + 'px')
      if (!vm.historyShow) {
        vm.adjustMapListHeight()
        vm.adjustTripListHeight()
      }
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
      vm.doUpdateLastPos(false)
    },
  },
}
//https://developers.google.com/maps/documentation/roads/snap
</script>
